module.exports = __webpack_public_path__ + "img/07.1b8e86e0.jpg";